import React from 'react';

const PersonalAreaIcon = ({
  width = '15',
  height = '15',
  stroke = '#222222',
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 15 15"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_3643_1477)">
      <path
        d="M12.2238 1.4248H2.77383C2.02824 1.4248 1.42383 2.02922 1.42383 2.7748V12.2248C1.42383 12.9704 2.02824 13.5748 2.77383 13.5748H12.2238C12.9694 13.5748 13.5738 12.9704 13.5738 12.2248V2.7748C13.5738 2.02922 12.9694 1.4248 12.2238 1.4248Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.42383 7.5H13.5738"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.50156 4.4626C7.31517 4.4626 7.16406 4.31149 7.16406 4.1251C7.16406 3.9387 7.31517 3.7876 7.50156 3.7876"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 4.4626C7.68639 4.4626 7.8375 4.31149 7.8375 4.1251C7.8375 3.9387 7.68639 3.7876 7.5 3.7876"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.50156 10.5373C7.31517 10.5373 7.16406 10.3862 7.16406 10.1998C7.16406 10.0134 7.31517 9.8623 7.50156 9.8623"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 10.5373C7.68639 10.5373 7.8375 10.3862 7.8375 10.1998C7.8375 10.0134 7.68639 9.8623 7.5 9.8623"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3643_1477">
        <rect width="15" height="15" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default PersonalAreaIcon;
